import { CHARGER_OR4_KEY, DEXCOM_STELO_KEY } from '@/app/consts/productKeys';

import type { ProductRecommendationCardProps } from '../ProductRecommendationCard';

/**
 * Configuration for product recommendations shown in MaxQuantityReachedMessage.
 *
 * To add a new product recommendation:
 * 1. Add a new entry to this object with a descriptive key
 * 2. Provide all required fields (productKey, title, description, image, urlPath)
 * 3. Optionally add a featureGate to conditionally show the product
 * 4. The RecommendedProductKey type will automatically include your new key
 */
export const PRODUCT_RECOMMENDATIONS_CONFIG = {
  or4Charger: {
    productKey: CHARGER_OR4_KEY,
    title: 'ring_pdp_2025_charger_set_or4_title',
    description: 'ring_pdp_2025_charger_set_or4_description',
    image: {
      alt: 'ring_pdp_2025_charger_set_or4_title',
      src: 'or4-pdp/oura-ring-4-extra-charger',
    },
    urlPath: 'store/accessories/charger-oura-4/select-size',
    dataCy: 'or4-charger-product-recommendation',
  },
  dexcomStelo: {
    productKey: DEXCOM_STELO_KEY,
    title: 'ring_pdp_2025_stelo_title',
    description: 'ring_pdp_2025_stelo_description',
    image: {
      alt: 'ring_pdp_2025_stelo_title',
      src: 'or4-pdp/stelo-glucose-biosensor-2-pack',
    },
    urlPath: 'store/dexcom/stelo-glucose-biosensor',
    dataCy: 'dexcom-stelo-product-recommendation',
    featureGate: 'dexcom_rollout',
  },
} as const satisfies Record<string, ProductRecommendationCardProps>;

export type RecommendedProductKey = keyof typeof PRODUCT_RECOMMENDATIONS_CONFIG;
